export const LYFORMBUILDER_VERSION = '1.0.5'
export const BEAUTIFIER_PATH = 'https://cdn.bootcdn.net/ajax/libs/js-beautify/1.14.7/beautifier.min.js'